module.exports = __webpack_public_path__ + "img/number-5.ecd82c7d.svg";